// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pound-button {\n  position: absolute;\n  bottom: 0;\n  height: 1.8rem;\n  width: 100%;\n  border-top: 0.02rem solid #DCE1EA;\n  background: #FFFFFF;\n  display: flex;\n  justify-content: center;\n}\n.pound-button > button {\n  margin-top: 0.16rem;\n  width: 5.6rem;\n  height: 0.8rem;\n  border-radius: 0.16rem;\n  background: #FFFFFF;\n  border: 0.02rem solid #999999;\n  font-size: 0.3rem;\n  font-family: Microsoft YaHei;\n  font-weight: 400;\n  color: #111111;\n}\n", ""]);
// Exports
module.exports = exports;
